export const FRACTIONS_TYPES = {
    PLASTIC: 'plastic',
    METAL: 'metal',
    GLASS: 'glass',
    MIX: 'mix'
}

export const MIX_FRACTION_IDS = [1, 2]

export const FRACTIONS = {
    [FRACTIONS_TYPES.PLASTIC]: {
        id: 1,
        type: 'plastic',
        name: 'Butelki plastikowe',
        description: 'Jednorazowe butelki z tworzyw sztucznych',
        details: 'pojemność do 3l',
        color: 'var(--color-warning)',
        activeIcon: 'FractionOn'
    },
    [FRACTIONS_TYPES.METAL]: {
        id: 2,
        type: 'metal',
        name: 'Puszki metalowe',
        description: 'Puszki metalowe',
        details: 'pojemność do 1 litra',
        color: 'var(--color-info)',
        activeIcon: 'FractionOn'
    },
    [FRACTIONS_TYPES.GLASS]: {
        id: 3,
        type: 'glass',
        name: 'Butelki szklane',
        description: 'Butelki szklane wielorazowego użytku',
        details: 'pojemność do 1,5 litra',
        color: 'var(--color-secondary-hover)',
        activeIcon: 'FractionOn'
    },
    [FRACTIONS_TYPES.MIX]: {
        id: 12,
        type: 'mix',
        name: 'Mix frakcji',
        description: 'Butelki plastikowe i puszki metalowe',
        details: 'butelki plastikowe + puszki metalowe',
        detailsTooltip: 'Opcja zbierania butelek plastikowych i puszek metalowych do jednego, wspólnego worka.<br/>Sprawdź, czy Twój operator dopuszcza taką możliwość',
        color: 'var(--color-dark)',
        activeIcon: 'FractionMix'
    }
}